import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetPerformanceReportForProfessionalsSummaryUseCaseInterface } from 'domain/usecases';

export class RemoteGetPerformanceReportForProfessionalsSummary
  implements GetPerformanceReportForProfessionalsSummaryUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetPerformanceReportForProfessionalsSummaryUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetPerformanceReportForProfessionalsSummaryUseCaseInterface.Params,
  ): Promise<GetPerformanceReportForProfessionalsSummaryUseCaseInterface.Result> {
    const requestUrl = generateUrl(this.url, params as any);

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
